import {call, METHODS} from '../http-client';
import { filtersToQueryString } from '../Filter/filter.service'

const ROUTE_PREFIX = 'providers';

export const getUserOfAMerchant = async (providerId, userId) => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, `${providerId}/users/${userId}`);
    } catch (e) {
        console.error(`getUserOfAMerchant error: ${e.message}`);
        throw e;
    }
}

export const getProviderUsers = async (providerId, search) => {
    try {
        const queryString = search ? filtersToQueryString({search}) : ''
        return await call(METHODS.GET, ROUTE_PREFIX, `${providerId}/users${queryString}`)
    } catch (e) {
        console.error(`getProviderUsers error: ${e.message}`);
        throw e;
    }
}

export const setProviderItemInventory = async (providerId, itemId, inventory) => {
    try {
        return await call(METHODS.PUT, ROUTE_PREFIX, `${providerId}/items/${itemId}/inventory`, inventory);
    } catch (e) {
        console.error(`setProviderItemInventory error: ${e}`);
        throw e;
    }
}

export const setProviderItemSellingOption = async (providerId, itemId, sellingOption) => {
    try {
        return await call(METHODS.PUT, ROUTE_PREFIX, `${providerId}/items/${itemId}/selling-option`, sellingOption)
    } catch (e) {
        console.error(`setProviderItemSellingOption error: ${e}`);
        throw e;
    }
}

function parseItemWithUnavailableUntil(item) {
    return item ? {
        ...item,
        unavailableUntil: item.unavailableUntil === 'Infinity' ? Infinity : item.unavailableUntil
    } : null;
}

export const getItemAvailability = async (providerId, itemId) => {
    const item = await call(METHODS.GET, ROUTE_PREFIX, `${providerId}/items/${itemId}/availability`);

    return parseItemWithUnavailableUntil(item);
}

export const patchItemAvailability = async (providerId, itemId, value) => {
    const item = await call(METHODS.PATCH, ROUTE_PREFIX, `${providerId}/items/${itemId}/availability`, {
        unavailableUntil: value
    });

    return parseItemWithUnavailableUntil(item);
}

export const isQuantityEnabled = (unavailableUntil, uncountable) => {
    return !(unavailableUntil !== null || uncountable);
}

export const isProviderACompany = (provider) => provider?.type === 'COMPANY'
export const isProviderAPos = (provider) => ['POINT_OF_SALE', 'MERCHANT'].includes(provider?.type);

export const getPerformanceReportConfigurations = async (providerId) => {
    return call(METHODS.GET, ROUTE_PREFIX, `${providerId}/performanceReportConfigurations`)
}

export const createPerformanceReportConfiguration = async (performanceReportConfiguration) => {
    return call(METHODS.POST, ROUTE_PREFIX, `${performanceReportConfiguration.providerId}/performanceReportConfigurations`, performanceReportConfiguration)
}

export const deletePerformanceReportConfiguration = async (performanceReportConfiguration) => {
    return call(METHODS.DELETE, ROUTE_PREFIX, `${performanceReportConfiguration.providerId}/performanceReportConfigurations/${performanceReportConfiguration.id}`)
}

export const updatePerformanceReportConfiguration = async (performanceReportConfiguration) => {
    return call(METHODS.PUT, ROUTE_PREFIX, `${performanceReportConfiguration.providerId}/performanceReportConfigurations/${performanceReportConfiguration.id}`, performanceReportConfiguration)
}

export const getAisles = async (providerId) => {
    return call(METHODS.GET, ROUTE_PREFIX, `${providerId}/aisles`)
}

export const getPickingPath = async (providerId) => {
    return call(METHODS.GET, ROUTE_PREFIX, `${providerId}/picking-path`)
}

export const setPickingPath = async ({ providerId, path }) => {
    return call(METHODS.POST, ROUTE_PREFIX, `${providerId}/picking-path`, { path })
}

export const getIntegrationState = async ({ providerId }) => {
    return call(METHODS.GET, ROUTE_PREFIX, `${providerId}/integrations-state`)
}

export const getPublishedProductsSummary = async (providerId) => {
    return call(METHODS.GET, ROUTE_PREFIX, `${providerId}/published-products-summary`)
}
